
export default {
  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: 'https://hirey.com/homepage/'
        }
      ]
    }
  },
  data() {
    return {
      scrollTop: 0
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll)
    this.listenerFunction()
  },
  destroyed() {
  },
  beforeDestroy() {
    this.beforeDestroy()
  },
  methods: {
    handleScroll() {
      Math.floor(document.documentElement.scrollTop || document.body.scrollTop);
    },
    listenerFunction(e) {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    beforeDestroy() {
      document.removeEventListener("scroll", this.listenerFunction);
    },
    goTop() {
      this.$refs.scrollBox.scrollTop = 0
    }
  }
}
